import httpClient from "@/services/index";
import { API_ENDPOINTS } from "./endpoints";

export const validateGroupId = async (groupid: string) => {
  const url = API_ENDPOINTS.GROUP;
  const params = {
    groupId: groupid,
  };
  const config = {
    params,
    headers: {
      "Accept-Version": "1.0",
    },
  };
  return httpClient.post(url, null, config).then((response) => {
    return response.data;
  });
};
